<template>
	<div class="loader" :class="sizeClass">
		<div class="loader__dots">
			<p></p>
			<p></p>
			<p></p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
	size?: string
}

const props = withDefaults(defineProps<Props>(), {
	size: 'middle'
})

const sizeClass = computed(() => `loader--${props.size}`)
</script>

<style>
.loader {display:flex;align-items:center;justify-content:center;margin:20px auto;}
.loader__dots {display:flex;gap:4px;}
.loader__dots p {width:8px;height:8px;border-radius:50%;background:var(--light4);animation:loader 1.4s infinite ease-in-out both;}
.loader__dots p:nth-child(1) {animation-delay:-.32s;}
.loader__dots p:nth-child(2) {animation-delay:-.16s;}

@keyframes loader {
	0%, 80%, 100% {transform:scale(0);}
	40% {transform:scale(1);}
}

.loader--small {margin:10px auto;}
.loader--small .loader__dots p {width:6px;height:6px;}
</style>